import { render } from "./LobbyScreen.vue?vue&type=template&id=399a4663&scoped=true"
import script from "./LobbyScreen.vue?vue&type=script&lang=js"
export * from "./LobbyScreen.vue?vue&type=script&lang=js"

import "./LobbyScreen.vue?vue&type=style&index=0&id=399a4663&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399a4663"]])

export default __exports__